module.exports = __webpack_public_path__ + "img/consult_info6.52691ce2.png";